import { BreakpointObserver } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'campus-collapsible-sheet',
  templateUrl: './collapsible-sheet.component.html',
  styleUrls: ['./collapsible-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleSheetComponent {
  @HostBinding('class')
  defaultClasses = ['collapsible-sheet', 'flex', 'flex-row', 'max-w-screen'];

  @ViewChild('aside', { static: true, read: ElementRef }) aside: ElementRef;

  @Input() expanded = false;

  @Output() expandedChange = new EventEmitter<boolean>();

  @HostBinding('style.--collapsible-sheet-aside-width')
  asideWidth: string;

  resizeLeftPos: string;

  private _leftOffset: number;
  private _grabbedResizer = false;

  constructor(public breakpointObserver: BreakpointObserver) {}

  updateExpanded(value: boolean) {
    this.expanded = value;
    this.expandedChange.emit(value);
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this._grabbedResizer) {
      event.preventDefault();

      const leftOffset = this.getLeftOffset();
      this.asideWidth = `${event.clientX - leftOffset}px`;
    }
  }
  onResizeMouseDown() {
    this._grabbedResizer = true;
    window.document.body.style.cursor = 'ew-resize';
  }
  @HostListener('window:mouseup')
  onResizeMouseUp() {
    this._grabbedResizer = false;
    this._leftOffset = null; // reset left offset to ensure correct handling on drag on other pages
    window.document.body.style.cursor = 'default';
  }

  private getLeftOffset() {
    if (!this._leftOffset) {
      this._leftOffset = this.aside?.nativeElement.getBoundingClientRect().left;
    }
    return this._leftOffset;
  }
}
